export default __webpack_public_path__ + "static/media/a1-4-12.71bceeb2.jpg";